import { memo } from 'react';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip.js';
import { X } from 'react-feather';
import styles from './style/Close.module.css';

type Props = {
  onClick: () => void;
};

export const CloseRow = memo(({ onClick }: Props) => {
  return (
    <Tooltip title="Close">
      <div
        className={styles.close}
        onClick={onClick}>
        <X className={styles.x} />
      </div>
    </Tooltip>
  );
});

export default CloseRow;